import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const WORD = "PURSUIT";

export default function Preloader({ onDone }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const start = performance.now();
    const dur = 1400;
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      setCount(Math.round(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(onDone, 350);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="flex overflow-hidden">
        {WORD.split("").map((ch, i) => (
          <motion.span
            key={i}
            className="font-display font-900 text-5xl md:text-7xl tracking-tight text-white"
            style={{ fontWeight: 900 }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
          >
            {ch}
          </motion.span>
        ))}
      </div>
      <motion.p
        className="font-mono text-[10px] tracking-[0.4em] text-smoke mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        MEDIA STUDIOS
      </motion.p>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 w-48">
        <div className="flex justify-between font-mono text-[10px] text-smoke mb-2">
          <span>LOADING REEL</span>
          <span data-testid="preloader-count">{count}%</span>
        </div>
        <div className="h-px bg-white/10">
          <div
            className="h-px bg-signal transition-[width] duration-100"
            style={{ width: `${count}%` }}
          />
        </div>
      </div>
    </motion.div>
  );
}
